export default __webpack_public_path__ + "static/media/Talent_ElementalAffinity.f9d7fe83.png";